import * as Immutable from 'immutable';
import { WidgetHelper } from './Widget';
export const wrapPropertiesWithWidgetTracking = (properties, isRequired) => {
    return { ...properties, isRequired };
};
// Way better than native version as it actually narrows down type
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
export const hasWidgetTracking = (property) => {
    return hasOwnProperty(property, 'isRequired') && property.isRequired === true;
};
const arrayContainsSameElements = (array1, array2) => {
    if (array1.length !== array2.length)
        return false;
    const sortedArr1 = [...array1].sort();
    const sortedArr2 = [...array2].sort();
    return sortedArr1.every((value, index) => value === sortedArr2[index]);
};
const allRequiredWidgetsAreCompleted = (widgetsCompletion) => {
    const requiredWidgetIds = widgetsCompletion.requiredWidgets.map((widget) => widget.trackingIdentifier);
    return arrayContainsSameElements(requiredWidgetIds, widgetsCompletion.completedWidgetIds.toArray());
};
const calculateRequiredWidgets = (content) => {
    const allRequiredWidgets = content.fragmentsById
        .filter((fragment) => WidgetHelper.isWidget(fragment))
        .map((fragment) => fragment)
        .filter((widget) => hasWidgetTracking(widget.value.properties))
        .toIndexedSeq()
        .toArray();
    return allRequiredWidgets;
};
const createWidgetsCompletion = (content) => {
    const requiredWidgets = calculateRequiredWidgets(content);
    return {
        requiredWidgets,
        completedWidgetIds: Immutable.Set(),
    };
};
const addCompletedWidget = (widgetCompletion, completedWidget) => {
    const widgetIsNotRequired = widgetCompletion.requiredWidgets.find((widget) => widget._id === completedWidget._id) === undefined;
    if (widgetIsNotRequired) {
        return widgetCompletion;
    }
    const updatedCompletedWidgetIds = widgetCompletion.completedWidgetIds.add(completedWidget.trackingIdentifier);
    return {
        completedWidgetIds: updatedCompletedWidgetIds,
        requiredWidgets: widgetCompletion.requiredWidgets,
    };
};
export const WidgetRequirements = {
    createWidgetsCompletion,
    allRequiredWidgetsAreCompleted,
    addCompletedWidget,
};
